import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable({
  providedIn: "root"
})
export class SeoService {
  constructor(private title: Title) {}

  getAppName(): string {
    return "Merri Catalog";
  }

  setTitle(title: string) {
    this.title.setTitle(title);
  }

  setTitleAppendToAppName(postfix: string) {
    this.setTitle(`${this.getAppName()} - ${postfix}`);
  }
}
